<div class="app-wrapper">
  <!-- header -->
  <app-header></app-header>
  <!-- content -->
  <div class="content">
    <div class="content-inner">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- footer -->
  <app-footer></app-footer>
</div>

<!-- drawer frame -->
<app-drawer-frame></app-drawer-frame>